module.exports = __webpack_public_path__ + "media/images/logos/teamtailor-1de4c86550f59a5488e6b60aa682e438.png";